// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"af4a9347","977":"e1cb3e0a"}[chunkId] + ".chunk.js";
};